import * as signalR from '@microsoft/signalr';
import { HubConnection, IHttpConnectionOptions } from '@microsoft/signalr';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SignalRConnectionFactoryService {
  createConnection(
    baseUrl: string,
    options: IHttpConnectionOptions,
    log?: (msg: string, data?: unknown) => void
  ): HubConnection {
    return new signalR.HubConnectionBuilder()
      .withUrl(baseUrl, options)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          if (retryContext.elapsedMilliseconds < 60000) {
            log?.('retryContext elapsedMilliseconds < 60 ' + retryContext.elapsedMilliseconds);
            const waitDuration = Math.random() * 5000;
            log?.('wait... ' + waitDuration);
            return waitDuration;
          }

          log?.('retryContext elapsedMilliseconds > 60 ' + retryContext.elapsedMilliseconds);
          const waitDuration = Math.random() * 15000;
          log?.('wait... ' + waitDuration);
          return waitDuration;
        }
      })
      .configureLogging(signalR.LogLevel.Debug)
      .build();
  }
}
